import styled from '@emotion/styled'
import { css } from '@emotion/react'
import { InputLabel, Select, SelectProps, FormControl } from '@mui/material'
import { theme as newTheme } from 'styles/theme/hav-theme'

interface SelectInfoStyledProps extends SelectProps {
  disabled?: boolean
}

interface LabelWrapperProps {
  disabled?: boolean
}

export const FormControlStyled = styled(FormControl)`
  .MuiSelect-select {
    padding: ${newTheme.spacing.xs} ${newTheme.spacing.md};
  }
  .MuiFormLabel-root,
  .Mui-error,
  .Mui-require {
    color: ${newTheme.colors.neutral.high};
  }

  .MuiOutlinedInput-root.MuiInputBase-root.MuiInputBase-colorPrimary.MuiInputBase-fullWidth.MuiInputBase-formControl.Mui-error {
    fieldset {
      border: ${newTheme.shapes.borderWidth.thin} ${newTheme.colors.alert.danger.main};
    }
  }
`

export const SelectInfoStyled = styled(Select)<SelectInfoStyledProps>`
  font-size: ${newTheme.typography.sizes.xs};
  padding: ${newTheme.spacing.sm};
  background-color: ${newTheme.colors.neutral.white};
  border-radius: ${newTheme.shapes.borderRadius.sm};
  padding: 0;
  cursor: pointer;

  em {
    font-style: normal;
    -webkit-text-fill-color: ${newTheme.colors.neutral.mediumhover};
  }

  fieldset {
    ${({ disabled }) =>
      disabled &&
      `
        border: ${newTheme.shapes.borderWidth.thin} ${newTheme.colors.neutral.clear} !important;
      `}
  }

  svg {
    color: ${newTheme.colors.primary.main};
  }

  div {
    display: flex;
    align-items: center;
  }

  .MuiSelect-select span {
    width: 100%;
    display: flex;
    overflow: hidden;

    ${({ disabled }) =>
      disabled &&
      css`
        -webkit-text-fill-color: ${newTheme.colors.neutral.mediumhover};
      `}
  }

  .Mui-disabled {
    cursor: not-allowed;
    background-color: ${newTheme.colors.neutral[100]};
  }

  #mui-component-select-address {
    padding-right: 0;
    margin-right: ${newTheme.spacing['2xm']};
  }
`

export const LabelInfosStyled = styled(InputLabel)`
  margin: 0;
  z-index: 0;
  cursor: inherit;
  color: ${newTheme.colors.neutral.high};
  font-size: ${newTheme.typography.sizes['2xs']};
  font-family: ${newTheme.typography.family.bold};
  font-weight: ${newTheme.typography.weight.lg};
  overflow: initial;
  position: relative;
  -webkit-transform: initial;
  transform: initial;

  .MuiInputLabel-asterisk {
    color: ${newTheme.colors.secondary};
  }
`

export const LabelWrapper = styled.div<LabelWrapperProps>`
  display: flex;
  align-items: center;
`
